import { ChatBubbleLeftIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { Duration } from "luxon";
import { useState } from "react";

import { PopoverMenu } from "@fronterahealth/frontera-ui-components/PopoverActionMenu/PopoverActionMenu";

import { MediaTargetPredictionFeedbackDialog } from "@components/MediaTargetPredictionFeedbackDialog/MediaTargetPredictionFeedbackDialog";
import { GoalMomentMediaTargetPrediction } from "@providers/VideoSessionProviderV2";

interface MomentRowProps {
  moment: GoalMomentMediaTargetPrediction;
  isActive: boolean;
  onClick: () => void;
}

export const MomentRow: React.FC<MomentRowProps> = ({ moment, isActive, onClick }) => {
  const [openFeedback, setOpenFeedback] = useState<boolean>(false);
  return (
    <div
      data-moment-id={moment.id}
      onClick={onClick}
      className={clsx(
        "group flex items-center justify-between pl-4 pr-1 cursor-pointer transition-all duration-200 hover:bg-limestone-50 rounded-md",
        isActive && "bg-limestone-100 hover:bg-limestone-100",
      )}
    >
      <span className={clsx("text-sm font-mono text-green-900 pl-4", isActive ? "font-semibold" : "font-thin")}>
        {Duration.fromObject({ seconds: moment.startTime }).toFormat("hh:mm:ss")} -{" "}
        {Duration.fromObject({ seconds: moment.endTime }).toFormat("hh:mm:ss")}
      </span>
      <div className="opacity-0 group-hover:opacity-100 transition-opacity">
        <PopoverMenu
          menuItems={[
            {
              label: "Leave Feedback",
              Icon: ChatBubbleLeftIcon,
              callback: () => setOpenFeedback(true),
            },
          ]}
        />
      </div>
      <MediaTargetPredictionFeedbackDialog
        open={openFeedback}
        setOpen={setOpenFeedback}
        mediaTargetPrediction={moment}
      />
    </div>
  );
};
